import { render, staticRenderFns } from "./DpoDashboard.vue?vue&type=template&id=ba9b00f2&scoped=true&"
import script from "./DpoDashboard.vue?vue&type=script&lang=js&"
export * from "./DpoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9b00f2",
  null
  
)

export default component.exports